import React from "react";
import FooterComponent from "./footerComponent";
import HeaderComponent from "./headerComponent";
export default function SurveySuccess() {
  let url = window.location.href;
  const ssid = url.split("/").pop();
  const uuid = url.split('/').slice(-2)[0];
  const college_list_url = process.env.REACT_APP_COLLEGE_URL + uuid + '/' + ssid;
  let image_url = process.env.REACT_APP_IMAGES + 'success_trophy.png';
  return (
    <div className="page-wrapper bg-blue font-robo wrapper-container">
      <div>
        <div className="logo-wrapper survey-padding-wrapper">
          <HeaderComponent />
          <div className="card card-wrapper">
            <div className="survey-card-body row" style={{padding:30}}>
            <div className="col-md-5">
             <img src={image_url} alt="img" className="trophy-img-success" />
            </div>
            <div className="col-md-7">
              <h2 className="main-head" style={{textAlign:'left'}}>Success!</h2>
              <p style={{textAlign:"left",marginBottom: "20px", marginTop: "20px",color:"black"}}>Congratulations on completing the MyCollegeList.com survey. Click on the "Go to My List" button below to see your results. Use our “What if...? Engine” at any time to see how changes in your admission factors affect your chances of admission. </p>
              <a href={college_list_url} className="none-change-btn text-align-center" ><input type="button" style={{textAlign:"center",float:"none",width: "40%"}} name="next" className="gotomylist-btn" value="Go to My List" /></a>
              <p style={{textAlign:"left",fontSize: "13px", marginTop: "10px",color:"black"}}>Please Note: MyCollegeList.com is a starting point only. Colleges also weigh other factors such as their relationships with high schools and their specific, evolving student body needs when making the final decisions. Further, it only contains colleges that are considered to be “most competitive” or “highly competitive”.</p>
            </div>
              </div>
            </div>
          </div>
          <FooterComponent />
        </div>
      </div>
  );
}
